;(function ($, window, document) {
    window.Footer = Me.view.extend({
        options: {},

        initialize: function () {
            _.bindAll(this, 'breakpointChanged', 'addEvents', 'toggleCollapseRow', 'calculateHeight', 'resizeHandler');
            this.addEvents();
        },
        addEvents: function () {
            Me.dispatch.subscribe('breakpointChanged', this.breakpointChanged);
        },
        breakpointChanged: function (e, params) {
            var view = this;

            if (params.breakpoint == '767-') {
                $(window).on('resize', this.resizeHandler);
                this.$('.row-ctn').each(function (index, value) {
                    view.calculateHeight($(value).find('.category-title'));
                    $(value).height($(value).find('.category-title').outerHeight(true));
                    $(value).find('.category-title').on('click', view.toggleCollapseRow);
                });

                this.$('.category-title').click(function (e) {
                    e.preventDefault();
                });
            } else {
                $(window).off('resize', this.resizeHandler);

                //prevent the last resize from the above listener to trigger after this calculation below
                setTimeout(function () {
                    view.$('.row-ctn').each(function (index, value) {
                        $(value).height('auto');
                        $(value).find('.category-title').off('click', view.toggleCollapseRow);
                    });
                }, 0);
            }
        },
        resizeHandler: function () {
            var view = this;
            this.$('.row-ctn').each(function (index, value) {
                view.calculateHeight($(value).find('.category-title'));
            });
        },
        toggleCollapseRow: function (e) {
            $(e.currentTarget).parent().toggleClass('open');
            this.calculateHeight($(e.currentTarget).parent());
        },
        calculateHeight: function (pTarget) {
            if (pTarget.hasClass('open')) {
                var totalHeight = 0;
                pTarget.children().each(function (index, value) {
                    totalHeight += parseInt($(value).outerHeight(true));
                });
                pTarget.height(totalHeight);
            } else {
                pTarget.height(pTarget.children("a").outerHeight(true));
            }
        }
    });
}(jQuery, window, document));
